import _ from 'lodash';
import moment from 'moment';
import { Voyage } from 'src/app/generated/services/transportation/voyages/voyage';

export interface VoyageLength1 {
  voyage: Voyage,
  days: number,
}

export function mapToVoyageLength1(voyages: Voyage[]): VoyageLength1[] {
  const sorted = voyages.filter(v => v.nors.length > 0)
    .sort((v1, v2) =>
      (v2.nors.sort((n1, n2) => n1.timestamp - n2.timestamp))[0].timestamp -
        (v1.nors.sort((n1, n2) => n1.timestamp - n2.timestamp))[0].timestamp);

  const lookups = _.groupBy(sorted, (item) => item.vesselName);
  for (const l of Object.keys(lookups)) {
    lookups[l] = lookups[l].sort((a, b) => a.shipVoyageNo.localeCompare(b.shipVoyageNo));
  }
  return sorted.map(v1 => {
    const voyages = lookups[v1.vesselName];
    const index = voyages.indexOf(v1);
    let numberOfDays: number = null!;
    if ((index + 1) !== voyages.length) {
      const nextVoyage = voyages[index + 1];
      const firstNorDate = v1.nors.filter(n => n.norType === 'loading')
        .sort((a, b) => b.timestamp - a.timestamp);
      const secondNorDate = nextVoyage.nors.filter(n => n.norType === 'loading')
        .sort((a, b) => b.timestamp - a.timestamp);

      if (firstNorDate.length > 0 && secondNorDate.length > 0) {
        numberOfDays = moment(secondNorDate[0].timestamp).diff(moment(firstNorDate[0].timestamp), 'days');
      }
    }

    return {
      voyage: v1,
      days: numberOfDays
    };
  });
}
